import { OIL_DICT_CORE } from './oilDictCore';
import { OIL_DICT_MAFIA } from './oilDictMafia';
import { OIL_DICT_EXTRA } from './oilDictExtra';
import { OIL_DICT_RULES } from './oilDictRules';

export const OIL_DICT = { ...OIL_DICT_CORE, ...OIL_DICT_MAFIA, ...OIL_DICT_EXTRA, ...OIL_DICT_RULES };

/**
 * Frases do servidor que vêm com apelido, número ou nível no meio.
 * $1, $2... são as partes capturadas (nomes e números não se traduzem).
 */
export const OIL_PATTERNS = [
  [/^Integridade LV\.(\d+)$/, { zh: '完整度 LV.$1', en: 'Integrity LV.$1' }],
  [/^INTEGRIDADE LV\.(\d+)$/, { zh: '完整度 LV.$1', en: 'INTEGRITY LV.$1' }],
  [/^(.+) \(você · teste\)$/, { zh: '$1（你 · 測試）', en: '$1 (you · test)' }],
  [/^KAKO (\d+)$/, { zh: 'KAKO $1', en: 'KAKO $1' }],
  [/^\+([\d.,]+) respeito$/, { zh: '+$1 聲望', en: '+$1 respect' }],
  [/^custou ([\d.,]+) Black Coins$/, { zh: '花費 $1 Black Coins', en: 'cost $1 Black Coins' }],
  [/^([\d.,]+) ativos$/, { zh: '$1 點金融資產', en: '$1 assets' }],
  [/^([\d.,]+) moedas pretas$/, { zh: '$1 Black Coins', en: '$1 Black Coins' }],
  [/^\+(\d+) no sucesso$/, { zh: '成功 +$1', en: '+$1 on success' }],
  [/^(\d+)% de (\d+)% bloqueio$/, { zh: '$1%（攔阻 $2%）', en: '$1% of $2% block' }],
  [/^LIBERA EM (.+)$/, { zh: '解鎖倒數 $1', en: 'UNLOCKS IN $1' }],
  [/^Todos os procurados · (.+)$/, { zh: '所有通緝犯 · $1', en: 'All wanted · $1' }],
  [/^EU FIZ \((\d+)\)$/, { zh: '我出手（$1）', en: 'I DID ($1)' }],
  [/^EU SOFRI \((\d+)\)$/, { zh: '我被打（$1）', en: 'I TOOK ($1)' }],
  [/^(\d+)º lugar —$/, { zh: '第 $1 名 —', en: '$1 place —' }],
  [/^% do FOX Dólar do alvo$/, { zh: '% 的目標 FOX Dólar', en: '% of the target FOX Dólar' }],
  [/^(\d+)% do FOX Dólar do alvo$/, { zh: '目標 FOX Dólar 的 $1%', en: '$1% of the target FOX Dólar' }],
  [/^Barril LV\.?$/, { zh: '油桶 LV.', en: 'Barrel LV.' }],
  [/^Barril LV\.?(\d+)$/, { zh: '油桶 LV.$1', en: 'Barrel LV.$1' }],
  [/^Suas usinas: LV\.1–(\d+)$/, { zh: '你的鑽油塔：LV.1–$1', en: 'Your rigs: LV.1–$1' }],
  [/^Suas envasadoras: LV\.1–(\d+)$/, { zh: '你的裝桶廠：LV.1–$1', en: 'Your bottling plants: LV.1–$1' }],
  [/^🔒 USINA LV\.(\d+)$/, { zh: '🔒 鑽油塔 LV.$1', en: '🔒 RIG LV.$1' }],
  [/^🔒 ENVASADORA LV\.(\d+)$/, { zh: '🔒 裝桶廠 LV.$1', en: '🔒 BOTTLING PLANT LV.$1' }],
  [/^: rende de (\d+) a (\d+)$/, { zh: '：產出 $1 至 $2', en: ': yields $1 to $2' }],
  [/^EXTRAIR (\d+)$/, { zh: '開採 $1', en: 'EXTRACT $1' }],
  [/^EXTRAIR PETRÓLEO$/, { zh: '開採石油', en: 'EXTRACT OIL' }],
  [/^faltam ([\d.,]+)$/, { zh: '還差 $1', en: 'need $1 more' }],
  [/^SABOTAGEM CONCLUÍDA! (.+) perdeu (.+) FOX Dólar\.$/, {
    zh: '破壞完成！$1 損失了 $2 FOX Dólar。',
    en: 'SABOTAGE DONE! $1 lost $2 FOX Dólar.' }],
  [/^OPERAÇÃO CONCLUÍDA! (.+) perdeu (.+) FOX Dólar\.$/, {
    zh: '行動完成！$1 損失了 $2 FOX Dólar。',
    en: 'OPERATION DONE! $1 lost $2 FOX Dólar.' }],
  [/^O escudo de (.+) bloqueou o golpe\.?$/, {
    zh: '$1 的護盾擋下了這一擊。',
    en: "$1's shield blocked the hit." }],
  [/^Você já bateu (\d+)x neste alvo hoje\. Procure outro império\.$/, {
    zh: '你今天已對這個目標出手 $1 次。換別的帝國吧。',
    en: 'You already hit this target $1x today. Find another empire.' }],
  [/^Faltam (.+) FOX Dólar para subir de posição$/, {
    zh: '還差 $1 FOX Dólar 才能往上一名',
    en: '$1 FOX Dólar to move up a position' }],
  [/^Faltam (.+) para entrar no Top 10 premiado 🏆$/, {
    zh: '還差 $1 就能進入有獎的前 10 名 🏆',
    en: '$1 to reach the paid Top 10 🏆' }],
  [/^Faltam (.+) de respeito para subir de posição$/, {
    zh: '還差 $1 聲望才能往上一名',
    en: '$1 respect to move up a position' }],
  [/^Faltam (.+) de respeito para entrar no Top 3 premiado 🏆$/, {
    zh: '還差 $1 聲望就能進入有獎的前 3 名 🏆',
    en: '$1 respect to reach the paid Top 3 🏆' }],
  [/^\+(\d+) Black Coins?$/, { zh: '+$1 Black Coins', en: '+$1 Black Coins' }],
  [/^(\d+) de integridade$/, { zh: '完整度 $1', en: '$1 integrity' }],
  [/^(\d+) para de produzir$/, { zh: '$1 就停止生產', en: '$1 stops producing' }],
  [/^Nível (\d+)$/, { zh: '等級 $1', en: 'Level $1' }],
  [/^LV\.(\d+)$/, { zh: 'LV.$1', en: 'LV.$1' }],
  [/^Perfurar (\d+) poços?$/, { zh: '鑽探 $1 口油井', en: 'Drill $1 wells' }],
  [/^Engarrafar (\d+) barris?$/, { zh: '裝滿 $1 桶石油', en: 'Bottle $1 barrels' }],
  [/^Vender (\d+) barris?$/, { zh: '賣出 $1 桶石油', en: 'Sell $1 barrels' }],
  [/^Recarregar ([\d.,]+) moedas hoje$/, { zh: '今天充值 $1 金幣', en: 'Recharge $1 coins today' }],
  [/^(\d+) dias? seguidos?$/, { zh: '連續 $1 天', en: '$1 days in a row' }],
  [/^(\d+) dias? → \+(\d+)$/, { zh: '$1 天 → +$2', en: '$1 days → +$2' }],
  [/^(\d+)º no ranking$/, { zh: '排行榜第 $1 名', en: '$1th in the ranking' }],
  [/^LV(\d+) \((.+)\)$/, { zh: 'LV$1（$2）', en: 'LV$1 ($2)' }],
  [/^Consumiu (\d+) gotas$/, { zh: '消耗了 $1 滴石油', en: 'Used $1 drops' }],
  [/^(\d+) barris LV(\d+)$/, { zh: '$1 桶 LV$2 石油', en: '$1 barrels LV$2' }],
  [/^Usina LV(\d+) comprada!$/, { zh: '鑽油塔 LV$1 已購買！', en: 'Rig LV$1 purchased!' }],
  [/^Envasadora LV(\d+) comprada!$/, { zh: '裝桶廠 LV$1 已購買！', en: 'Bottling plant LV$1 purchased!' }],
  [/^(\d+)º$/, { zh: '第$1', en: '#$1' }],
  [/^(\d+)º lugar$/, { zh: '第 $1 名', en: '#$1 place' }],
];
